import request from "@/api";
import { BaseService } from "@/api/services/baseService";
import type {
    PurchaseOverviewVo,
    ServiceCostIncomeVo,
    MemberRevenueStatisticVo,
    MemberCustomerVo,
    ShippingDemandStatisticVo,
    ShipStatisticVo,
    HotShipRouteVo,
    HotShipDestinationPortVo,
    ShipInfoServiceFeeStatisticVo,
    Page,
    ProductStatisticAllVo,
    ProductPagingParams,
    ProductStatisticAllParams,
    ProductOperationVo,
    FunctionOperationGlobalVo,
    FunctionEntryDistributionVo,
    ProductTrendVo,
    ProductStaticDataVo,
    PurchaseRankingVo,
    VisitorRegionVo,
    SalesRegionVo,
    ReceiveRegionTopVo,
    CustomVisitPagingVo,
    CustomerVisitorVo,
    FunctionModuleTreeDTO,
    VisitorCountDetailVo,
    VisitCountDetailVo
} from "@zhihaoscm/entity";
import type { RegisterCustomerVo } from "@/entity/dashboard";

export class DashboardService extends BaseService<unknown, unknown, unknown, unknown> {
    // 砂石交易看板-概览
    public async getPurchaseOverview(params: {
        scope?: string | number;
        startDate?: string;
        finishDate?: string;
    }): Promise<PurchaseOverviewVo> {
        const { data } = await this.service.get(`${this.path}/purchase/overview`, { params });
        return data;
    }
    // 砂石交易看板-服务费
    public async getPurchaseServiceCost(params: {
        statisticsScope?: string | number;
        statisticsBeiginTime?: string;
        statisticsEndTime?: string;
        scope?: number;
        beiginTime?: string;
        endTime?: string;
        analysisScope?: string | number;
        analysisMonth?: string;
        pieChartScope?: number;
        pieChartBeiginTime?: string;
        pieChartEndTime?: string;
    }): Promise<ServiceCostIncomeVo> {
        const { data } = await this.service.get(`${this.path}/purchase/service/cost`, { params });
        return data;
    }
    // 链云用户看板-注册用户统计
    public async getRegisteredCustomerStatistic(params?: {
        scope?: number;
        beginTime?: string;
        endTime?: string;
    }): Promise<RegisterCustomerVo> {
        const { data } = await this.service.get(`${this.path}/customer/registered-customer-statistic`, { params });
        return data;
    }
    // 链云用户看板-会员营收统计
    public async getMemberRevenueStatistic(params?: {
        scope?: number;
        beginTime?: string;
        endTime?: string;
    }): Promise<MemberRevenueStatisticVo> {
        const { data } = await this.service.get(`${this.path}/customer/member-revenue-statistic`, { params });
        return data;
    }
    // 链云用户看板-会员用户统计
    public async getMemberCustomerStatistic(params?: {
        scope?: number;
        beginTime?: string;
        endTime?: string;
    }): Promise<MemberCustomerVo> {
        const { data } = await this.service.get(`${this.path}/customer/member-customer-statistic`, { params });
        return data;
    }
    // 链云用户看板-用户转化分析
    public async getCustomerConvertAnalysis(params: {
        scope?: number;
        beginTime?: string;
        endTime?: string;
    }): Promise<MemberCustomerVo> {
        const { data } = await this.service.get(`${this.path}/customer/customer-convert-analysis`, { params });
        return data;
    }
    // 链云用户看板-注册用户新增分析
    public async getAddRegisteredCustomerAnalysis(params: {
        scope?: string | number;
        date?: string;
    }): Promise<RegisterCustomerVo> {
        const { data } = await this.service.get(`${this.path}/customer/add-registered-customer-analysis`, { params });
        return data;
    }
    // 链云用户看板-会员费用新增分析
    public async getAddMemberRevenueAnalysis(params: {
        scope?: string | number;
        date?: string;
    }): Promise<MemberRevenueStatisticVo> {
        const { data } = await this.service.get(`${this.path}/customer/add-member-revenue-analysis`, { params });
        return data;
    }
    // 链云用户看板-会员用户新增统计
    public async getAddMemberCustomerStatistic(params: {
        scope?: string | number;
        beginTime?: string;
        endTime?: string;
    }): Promise<MemberCustomerVo> {
        const { data } = await this.service.get(`${this.path}/customer/add-member-customer-statistic`, { params });
        return data;
    }
    // 链云用户看板-会员用户新增分析
    public async getAddMemberCustomerAnalysis(params: {
        scope?: string | number;
        date?: string;
    }): Promise<MemberCustomerVo> {
        const { data } = await this.service.get(`${this.path}/customer/add-member-customer-analysis`, { params });
        return data;
    }
    // 物流看板-船运需求统计
    public async getShippingDemandStatistic(params?: {
        scope?: number;
        beginTime?: string;
        endTime?: string;
    }): Promise<ShippingDemandStatisticVo> {
        const { data } = await this.service.get(`${this.path}/logistics/shipping-demand-statistic`, { params });
        return data;
    }
    // 物流看板-船务信息服务费统计
    public async getShipInfoServiceFeeStatistic(params?: {
        scope?: number;
        beginTime?: string;
        endTime?: string;
    }): Promise<ShipInfoServiceFeeStatisticVo> {
        const { data } = await this.service.get(`${this.path}/logistics/ship-info-service-fee-statistic`, { params });
        return data;
    }
    // 物流看板-船运需求转化分析
    public async getShippingDemandConvertAnalysis(params: {
        scope?: string | number;
        beginTime?: string;
        endTime?: string;
    }): Promise<ShippingDemandStatisticVo> {
        const { data } = await this.service.get(`${this.path}/logistics/shipping-demand-convert-analysis`, { params });
        return data;
    }
    // 物流看板-船舶统计
    public async getShipStatistic(params?: {
        scope?: number;
        beginTime?: string;
        endTime?: string;
    }): Promise<ShipStatisticVo> {
        const { data } = await this.service.get(`${this.path}/logistics/ship-statistic`, { params });
        return data;
    }
    // 物流看板-船运单数据分析
    public async getShipOrderDataAnalysis(params: {
        scope?: string | number;
        date?: string;
    }): Promise<ShippingDemandStatisticVo> {
        const { data } = await this.service.get(`${this.path}/logistics/ship-order-data-analysis`, { params });
        return data;
    }
    // 物流看板-热门航线排行
    public async getHotShipRouteRank(params: { beginTime?: string; endTime?: string }): Promise<HotShipRouteVo[]> {
        const { data } = await this.service.get(`${this.path}/logistics/hot-ship-route-rank`, { params });
        return data;
    }
    // 物流看板-热门目的地排行
    public async getHotShipDestinationPortRank(params: {
        beginTime?: string;
        endTime?: string;
    }): Promise<HotShipDestinationPortVo[]> {
        const { data } = await this.service.get(`${this.path}/logistics/hot-ship-destination-port-rank`, { params });
        return data;
    }
    // 物流看板-新增船运需求统计
    public async getAddShippingDemandStatistic(params: {
        scope?: string;
        beginTime?: string;
        endTime?: string;
    }): Promise<ShippingDemandStatisticVo> {
        const { data } = await this.service.get(`${this.path}/logistics/add-shipping-demand-statistic`, { params });
        return data;
    }
    // 物流看板-新增船运需求分析
    public async getAddShippingDemandAnalysis(params: {
        scope?: string | number;
        date?: string;
    }): Promise<ShippingDemandStatisticVo> {
        const { data } = await this.service.get(`${this.path}/logistics/add-shipping-demand-analysis`, { params });
        return data;
    }

    // 物流看板-船务信息服务费新增分析
    public async getAddShipInfoServiceFeeAnalysis(params: {
        scope?: string | number;
        date?: string;
    }): Promise<ShipInfoServiceFeeStatisticVo> {
        const { data } = await this.service.get(`${this.path}/logistics/add-ship-info-service-fee-analysis`, {
            params
        });
        return data;
    }

    // 物流看板-船舶新增统计
    public async getAddShipStatistic(params: {
        scope?: string | number;
        beginTime?: string;
        endTime?: string;
    }): Promise<ShipStatisticVo> {
        const { data } = await this.service.get(`${this.path}/logistics/add-ship-statistic`, { params });
        return data;
    }

    // 商品运营分析-统计商品运营总信息
    public async getProductStatisticAll(params: ProductStatisticAllParams): Promise<ProductStatisticAllVo> {
        const { data } = await this.service.get(`${this.path}/product/statistic-all`, { params });
        return data;
    }

    // 商品运营分析-分页查询商品运营信息
    public async getProductPaging(params: ProductPagingParams): Promise<Page<ProductOperationVo>> {
        const { data } = await this.service.get(`${this.path}/product/paging`, { params });
        return data;
    }

    // 商品运营分析-导出商品运营信息
    public async exportProductOperation(
        params: ProductStatisticAllParams & {
            showColumns: string[];
        },
        filename: string
    ) {
        const response = (await this.service.get(`${this.path}/product/export-product-operation`, {
            params,
            responseType: "blob"
        })) as Blob;

        const url = window.URL.createObjectURL(response);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        return response;
    }

    // 功能运营分析 - 功能模块筛选
    public async getStatisticByFunction(params: {
        scope?: number;
        beginTime?: string;
        endTime?: string;
        functionType: number;
    }): Promise<FunctionEntryDistributionVo> {
        const { data } = await this.service.get(`${this.path}/function/statistic/function`, { params });
        return data;
    }

    // 功能模块 - 列表汇总
    public async functionQueryAll(params: {
        scope?: number;
        beginTime?: string;
        endTime?: string;
        sortKey?: string;
        sortOrder?: string;
    }): Promise<FunctionModuleTreeDTO[]> {
        const { data } = await this.service.get(`${this.path}/function/query-all`, { params });
        return data;
    }

    // 功能运营分析 - 功能模块分析汇总
    public async getStatisticAll(params: {
        scope?: number;
        beginTime?: string;
        endTime?: string;
    }): Promise<FunctionOperationGlobalVo> {
        const { data } = await this.service.get(`${this.path}/function/statistic-all`, { params });
        return data;
    }

    // 功能模块分析汇总 - 导出功能模块
    public async exportFunction(params: { scope?: number; beginTime?: string; endTime?: string; }, filename: string) {
        const response = (await this.service.get(`${this.path}/function/export-function`, {
            params,
            responseType: "blob"
        })) as Blob;

        const url = window.URL.createObjectURL(response);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        return response;
    }

    // 商品详情-数据统计与价格销量分布
    public async getProductAnalysisStaticData(params: {
        productId: string;
        beginTime?: string;
        endTime?: string;
    }): Promise<ProductStaticDataVo> {
        const { data } = await this.service.get(`${this.path}/product/analysis/static-data`, {
            params
        });
        return data;
    }

    // 商品详情-趋势分析
    public async getProductAnalysisTrendData(params: {
        productId: string;
        beginTime?: string;
        endTime?: string;
        timeGranularity: number;
    }): Promise<ProductTrendVo> {
        const { data } = await this.service.get(`${this.path}/product/analysis/trend-data`, {
            params
        });
        return data;
    }

    // 商品详情-采购排名TOP5
    public async getProductAnalysisPurchaseTop5(params: {
        productId: string;
        beginTime?: string;
        endTime?: string;
        sortType: number;
    }): Promise<PurchaseRankingVo[]> {
        const { data } = await this.service.get(`${this.path}/product/analysis/purchase-top5`, {
            params
        });
        return data;
    }

    // 获取商品全部数据对应的时间范围
    public async getAllTime(): Promise<{
        beginTime: string;
        endTime: string;
    }> {
        const { data } = await this.service.get(`${this.path}/product/getAllTime`);
        return data;
    }

    // 商品详情-受众画像-访客地域分布接口（默认省级）
    public async getVisitorRegion(params: {
        productId: string;
        areaLevel: number;
        beginTime?: string;
        endTime?: string;
    }): Promise<VisitorRegionVo[]> {
        const { data } = await this.service.get(`${this.path}/product/get-visitor-region`, {
            params
        });
        return data;
    }

    // 商品详情-受众画像-销售情况地域分布接口（默认省级）
    public async getSalesRegion(params: {
        productId: string;
        areaLevel: number;
        beginTime?: string;
        endTime?: string;
    }): Promise<SalesRegionVo[]> {
        const { data } = await this.service.get(`${this.path}/product/get-sales-region`, {
            params
        });
        return data;
    }

    // 商品详情-受众画像-收货地域排名 TOP5 接口（默认销量优先）
    public async getReceiveRegionTop5(params: {
        productId: string;
        sortType: number;
        beginTime?: string;
        endTime?: string;
    }): Promise<ReceiveRegionTopVo[]> {
        const { data } = await this.service.get(`${this.path}/product/get-receive-region-top5`, {
            params
        });
        return data;
    }

    // 分页用户商品访问详情统计
    public async customVisitPaging(
        params: ProductPagingParams & {
            outerKeyword?: string;
        }
    ): Promise<Page<CustomVisitPagingVo>> {
        const { data } = await this.service.get(`${this.path}/product/custom-visit-paging`, {
            params
        });
        return data;
    }

    // 单个商品-分页用户商品访问详情统计
    public async customVisitPagingByProductId(params: {
        productId: string;
        page?: number;
        size?: number;
        scope?: number;
        keyword?: string;
        beginTime?: Date;
        endTime?: Date;
    }): Promise<Page<CustomVisitPagingVo>> {
        const { data } = await this.service.get(`${this.path}/product/custom-visit-paging/single`, {
            params
        });
        return data;
    }

    // 分页用户商品详情统计
    public async customPaging(
        params: ProductPagingParams & {
            outerKeyword?: string;
        }
    ): Promise<Page<ProductOperationVo>> {
        const { data } = await this.service.get(`${this.path}/product/custom-paging`, {
            params
        });
        return data;
    }

    // 单个商品-分页用户商品详情统计
    public async customPagingByProductId(params: {
        productId: string;
        page?: number;
        size?: number;
        scope?: number;
        keyword?: string;
        beginTime?: Date;
        endTime?: Date;
        sortKey?: string;
        sortOrder?: "asc" | "desc";
    }): Promise<Page<ProductOperationVo>> {
        const { data } = await this.service.get(`${this.path}/product/custom-paging/single`, {
            params
        });
        return data;
    }

    // 访问量明细
    public async functionVisitorsDetail(params: {
        page?: number;
        size?: number;
        sortKey?: string;
        sortOrder?: string;
        scope?: number;
        keyword?: string;
        beginTime?: string;
        endTime?: string;
    }): Promise<Page<CustomerVisitorVo>> {
        const { data } = await this.service.get(`${this.path}/function/visitors/detail`, { params });
        return data;
    }

    // 查询访问次数明细
    public async findVisitorCountDetail(params:{
        moduleName: number;
        scope?: number;
        beginTime?: string;
        endTime?: string;
        page: number;
        size: number;
        sortKey?: string;
        sortOrder?: string;
        /**
         * 表格内的开始时间
         */
        innerBeginTime?: string;
        /**
         * 表格内的结束时间
         */
        innerEndTime?: string;
        /**
         * 手机号/实名
         */
        keyword?: string;
        /**
         * 终端 多选
         */
        clientType?: number[];
    }): Promise<VisitorCountDetailVo[]> {
        const { data } = await this.service.get(`${this.path}/function/find-visitor-count-detail`, {
            params
        });
        return data;
    }

    // 导出访问次数明细
    public async exportVisitorCountDetail(params: any, filename: string) {
        const response = (await this.service.get(`${this.path}/function/export-visitor-count-detail`, {
            params,
            responseType: "blob"
        })) as Blob;
        const url = window.URL.createObjectURL(response);
        const link = document.createElement("a");

        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        return response;
    }

    // 查询访问人数明细
    public async findVisitCountDetail(params:{
        moduleName: number;
        scope?: number;
        beginTime?: string;
        endTime?: string;
        page: number;
        size: number;
        sortKey?: string;
        sortOrder?: string;
        /**
         * 手机号/实名
         */
        keyword?: string;
        /**
         * 终端 多选
         */
        clientType?: number[];
    }): Promise<VisitCountDetailVo[]> {
        const { data } = await this.service.get(`${this.path}/function/find-visit-count-detail`, {
            params
        });
        return data;
    }

    // 导出访问人数明细
    public async exportFindVisitCountDetail(params: any, filename: string) {
        const response = (await this.service.get(`${this.path}/function/export-visit-count-detail`, {
            params,
            responseType: "blob"
        })) as Blob;
        const url = window.URL.createObjectURL(response);
        const link = document.createElement("a");

        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        return response;
    }
}

export const dashboardService = new DashboardService("/admin/dashboard", request.service);
